import { memo } from "react";
import { clsx } from "clsx";

import { SortOrder } from "@/shared/services/ReadingService";

import cls from "./SortBtn.module.scss";

interface SortBtnProps {
  className?: string;
  order?: SortOrder;
  onClick: () => void;
}

export const SortBtn = memo((props: SortBtnProps) => {
  const { className, order, onClick } = props;

  return (
    <div className={clsx(cls.SortBtn, {}, [className])} onClick={onClick}>
      <div className={clsx(cls.Arrow, { [cls.isActive]: order === SortOrder.ASC }, [cls.Up])} />
      <div className={clsx(cls.Arrow, { [cls.isActive]: order === SortOrder.DESC }, [cls.Down])} />
    </div>
  );
});
